var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse180(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1322,
    height: 449,
    viewBox: "0 0 1322 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2332_4275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1631.46 684.431C1584.76 873.072 1337.71 974.211 1079.65 910.331C821.583 846.451 -61.2743 610.397 -14.5787 421.756C696.21 492.114 1318.32 60.4562 1433.04 246.697C1691.11 310.577 1678.15 495.791 1631.46 684.431Z",
    fill: "#62DBEB",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2332_4275",
    x: -330.363,
    y: -114.345,
    width: 2302.51,
    height: 1357.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 157,
    result: "effect1_foregroundBlur_2332_4275"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse180);
export default __webpack_public_path__ + "static/media/Ellipse 180.caa9ac3490b6bcdff94f91867734d6c3.svg";
export { ForwardRef as ReactComponent };